/**
 * FONBEX brand configuration — source unique de vérité pour la marque.
 * Aucun libellé de marque ne doit être écrit en dur dans les composants.
 * Toute nouvelle référence de marque doit consommer BRAND.* ci-dessous.
 */
import { FoundationHorizontal, FoundationSymbol, FoundationCompact,
         FoundationFavicon } from "@/fonbex/logos";

const readEnv = (key, fallback) =>
  (typeof process !== "undefined" && process.env?.[key]) || fallback;

export const BRAND = {
  // Identity
  name: "Fonbex",
  nameUppercase: "FONBEX",
  legalName: "Fonbex",
  slogan: "Gérez, suivez et valorisez votre immobilier.",
  tagline: "La plateforme française de gestion immobilière, locative et patrimoniale.",

  // Domains & URLs (drive by env at build-time; safe placeholder in preview)
  primaryDomain: readEnv("REACT_APP_BRAND_DOMAIN", "fonbex.fr"),
  ownerAppUrl: readEnv("REACT_APP_OWNER_APP_URL", "https://fonbex.fr/app"),
  tenantAppUrl: readEnv("REACT_APP_TENANT_APP_URL", "https://fonbex.fr/tenant"),
  publicSiteUrl: readEnv("REACT_APP_PUBLIC_SITE_URL", "https://fonbex.fr"),

  // Contacts
  supportEmail: "contact@fonbex.fr",
  legalEmail: "legal@fonbex.fr",
  noreplyEmail: "no-reply@fonbex.fr",

  // Product names surfaced in UI
  productName: "Fonbex",
  tenantSpaceName: "Espace locataire Fonbex",

  // Logo (Foundation concept — V1 official)
  logo: {
    Horizontal: FoundationHorizontal,
    Symbol: FoundationSymbol,
    Compact: FoundationCompact,
    Favicon: FoundationFavicon,
  },

  // Palette (Fonbex official)
  colors: {
    primary: "#2454D3",
    primaryHover: "#1D43A8",
    primaryPressed: "#163380",
    night: "#102A56",
    lightBlue: "#EAF1FF",
    white: "#FFFFFF",
    surface: "#F6F8FC",
    accent: "#E63946",
    accentHover: "#C9323D",
    textPrimary: "#1C2434",
    textSecondary: "#657084",
    border: "#E2E8F0",
    success: "#0FA968",
    warning: "#D97706",
  },

  // SEO
  seo: {
    title: "Fonbex — Logiciel de gestion immobilière, locative et SCI",
    description:
      "Fonbex centralise vos biens, SCI, locataires, baux, loyers, charges, crédits et documents dans une solution de gestion immobilière claire et professionnelle.",
    ogImage: "/og-image.png",
  },
};

export default BRAND;
